<foo-control-label [templateOptions]="templateOptions" [control]="control"></foo-control-label>
<button [disabled]="dataShimmer" type="button" class="foo-btn-outline-secondary w-100" (click)="selectItems()">
  {{ (templateOptions?.placeholder | translate) + " (" + selectedItemsCount + ")"}}
</button>
<foo-control-errors *ngIf="!templateOptions?.readonly && !templateOptions?.hideErrors" [control]="control"
  [errorMessages]="errors"></foo-control-errors>
